import app from './components/app';
import './css/topheader.scss';
import { funcFactory, TYPE_ENUM } from './utils';
import plugins from './plugins';

(function() {
    const loadVue = () => {
        if (!window.Vue) {
            let script = document.createElement('script');
            script.src = '//static.koocdn.com/lib/vue/2.x/vue.js';
            document.head.appendChild(script);
            return new Promise((resolve, reject) => {
                script.onload = () => {
                    resolve(window.Vue);
                };
            });
        }
        return new Promise((resolve, reject) => {
            resolve(window.Vue);
        });
    };
    let _pendingData = {}; // 防止vue还没下载完就调用changeTitle
    let _app = null;

    const FixedTopHeader = function({
        selector = 'body',
        parent = document.body,
        type,
        title,
        zindex = 101,
        position,
        scene = '',
        channelValue = 'm-kaoyan',
        isMKaoyan = false,
    }) {
        if (_app) {
            return;
        }
        // 插入根节点
        if (typeof selector === 'string') {
            selector = document.querySelector(selector);
        }
        const _topHeaderRoot = document.createElement('div');
        if (position === 'before') {
            let first = parent.firstChild;
            parent.insertBefore(_topHeaderRoot, first);
        } else {
            parent.appendChild(_topHeaderRoot);
        }
        let self = this;
        self.app = {};
        // 加载vue
        loadVue().then((_Vue) => {
            type = TYPE_ENUM.includes(type) ? type : TYPE_ENUM[0];
            // 插入默认值
            _pendingData = {
                title,
                scene,
                type,
                zindex,
                channelValue,
                isMKaoyan,
                ..._pendingData,
            };

            app.data = {
                ...app.data,
                ..._pendingData,
            };
            plugins.forEach((plugin) => {
                _Vue.use(plugin);
            });

            _app = new _Vue(app);
            _app.$mount(_topHeaderRoot);
            Object.keys(_app).forEach((_key) => {
                self[_key] = _app[_key];
            });
        });
    };
    // 设置公用方法，防止 Vue 实例在还没创建之前调用
    FixedTopHeader.prototype.changeType = funcFactory(_pendingData, 'type', (_type) => TYPE_ENUM.includes(_type));
    FixedTopHeader.prototype.changeTitle = funcFactory(_pendingData, 'title');
    FixedTopHeader.prototype.changeScene = funcFactory(_pendingData, 'scene');
    FixedTopHeader.prototype.inKoolearnApp = funcFactory(_pendingData, 'visible');
    window.FixedTopHeader = FixedTopHeader;
})();
